//@flow
import TimeUtils from 'common/utils/TimeUtils';
/*========================================
=            Type definitions            =
========================================*/
type setNotificationStateActionType = { type: string, permission: string };
type setNotificationShownAtTimeType = {
    type: string,
    shownAt: string | Object
};
type toggleActionType = { type: string, flag: boolean };
type setPreviousEventsListActionType = {
    type: string,
    eventsList: Array<string>
};

type ActionType =
    | setNotificationStateActionType
    | setNotificationShownAtTimeType
    | toggleActionType
    | setPreviousEventsListActionType
    | Function;
// type DispatchType = (action: ActionType) => ActionType;
/*=====  End of Type definitions  ======*/

class EventNotificationActions {
    static +SET_NOTIFICATION_STATE: string = 'SET_NOTIFICATION_STATE';
    static +SET_PREVIOUS_EVENTS_LIST: string = 'SET_PREVIOUS_EVENTS_LIST';
    static +SET_NOTIFICATION_PREVIOUSLY_SHOWN: string =
        'SET_NOTIFICATION_PREVIOUSLY_SHOWN';
    static +SET_NOTIFICATION_SHOWN_AT: string = 'SET_NOTIFICATION_SHOWN_AT';
    static +TOGGLE_NOTIFICATION_INFO: string = 'TOGGLE_NOTIFICATION_INFO';

    static setNotificationState = (permission: string): ActionType => {
        return {
            type: EventNotificationActions.SET_NOTIFICATION_STATE,
            permission
        };
    };

    static setPreviousEventsList = (eventsList: Array<string>): ActionType => {
        return {
            type: EventNotificationActions.SET_PREVIOUS_EVENTS_LIST,
            eventsList
        };
    };

    static setNotificationShownAtTime = (
        shownAt: string = TimeUtils.format(TimeUtils.now())
    ): ActionType => {
        return {
            type: EventNotificationActions.SET_NOTIFICATION_SHOWN_AT,
            shownAt
        };
    };

    static setNotificationPreviouslyShown = (flag: boolean): ActionType => {
        return {
            type: EventNotificationActions.SET_NOTIFICATION_PREVIOUSLY_SHOWN,
            flag
        };
    };

    static toggleNotificationInfo = (flag: boolean = true): ActionType => {
        return {
            type: EventNotificationActions.TOGGLE_NOTIFICATION_INFO,
            flag
        };
    };
}

const {
    setNotificationState,
    setPreviousEventsList,
    setNotificationPreviouslyShown,
    setNotificationShownAtTime,
    toggleNotificationInfo
} = EventNotificationActions;

export default EventNotificationActions;
export {
    setNotificationState,
    setPreviousEventsList,
    setNotificationPreviouslyShown,
    setNotificationShownAtTime,
    toggleNotificationInfo
};
